<script>
  import UploadFiles from './UploadFiles.svelte';
  import SimpleFileUploader from '../components/SimpleFileUploader.svelte';
  import Loader from './../components/Loader.svelte';
  import { onMount } from 'svelte';
  import { Modal } from 'bootstrap';
  import { createForm } from 'svelte-forms-lib';
  import FormInput from 'components/FormControls/FormInput.svelte';
  import FormTextarea from 'components/FormControls/FormTextarea.svelte';
  import { customInputEvent, searchKeyByValue } from 'components/Helper.js';

  import * as yup from 'yup';
  import { configItem } from './Helper';
  export let handleClick = (e) => {};
  export let handleDelete = (e) => {};
  export let entityId = 0;
  let displayfiles = [];
  let isAjaxLoading = false;
  let canDelete = false;
  export const showModal = (subject, body, attachments, showDelete) => {
    canDelete = showDelete ? showDelete : false;
    isAjaxLoading = true;
    $form = { ...defaultValue };
    $errors = {};
    $form.emailSubject = subject;
    $form.emailBody = body;
    $form.attachments = attachments || [];
    addTaskMailModal.show();
    setTimeout(() => {
      displayfiles = attachments || [];
      isAjaxLoading = false;
    }, 100);
  };

  let addTaskMailModal;
  let isFormPending = false;
  let defaultValue = {
    emailSubject: '',
    emailBody: '',
    attachments: [],
  };

  const { form, errors, handleChange, handleSubmit } = createForm({
    initialValues: { ...defaultValue },
    validationSchema: yup.object().shape({
      emailSubject: yup.string().required('Subject is required'),
      emailBody: yup.string().required('Email Body is required'),
    }),
    onSubmit: (values) => {
      handleClick(values);
      addTaskMailModal.hide();
    },
  });

  onMount(() => {
    addTaskMailModal = new Modal(document.getElementById('mailtemplate'), {
      keyboard: false,
    });
  });
</script>

<!-- Button trigger modal -->

<!-- Modal -->

<div
  class="modal fade common-modal"
  id="mailtemplate"
  role="dialog"
  tabindex="-1"
  aria-labelledby="mailtemplate"
  aria-hidden="true"
>
  <div
    class="modal-dialog"
    role="document"
  >
    <div class="modal-content">
      <div class="modal-header">
        <h5
          class="modal-title font-size-14"
          id="exampleModalLabel"
        >
          Setup / Update Mail Template
        </h5>
        <button
          type="button"
          class="close btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true"></span>
        </button>
      </div>
      <div class="modal-body p-3 modal-body-height">
        <div class="form-group mb-3">
          <FormInput
            name="emailSubject"
            label="Subject"
            type="text"
            placeholder="Enter Subject"
            error={$errors.emailSubject}
            bind:value={$form.emailSubject}
            maxLength={configItem.maxLength.input}
            handleChange={handleChange}
          />
        </div>
        <div class="form-group mb-3">
          <FormTextarea
            Style="height:320px; resize: auto;"
            maxLength={configItem.maxLength.body}
            name="emailBody"
            label="Email Body"
            placeholder="Enter Message"
            handleChange={handleChange}
            error={$errors.emailBody}
            bind:value={$form.emailBody}
          />
        </div>
        {#if isAjaxLoading}
          <div class="d-flex align-items-center justify-content-center h-100">
            <Loader />
          </div>
        {:else}
          <div class="form-group mb-3">
            {#if !entityId || entityId == 0}
              <div class="alert alert-info">
                Please save the task template first before uploading email attachments.
              </div>
            {:else}
              <!-- <UploadFiles/> -->
              <SimpleFileUploader
                on:fileChanged={(event) => {
                  if (event.detail.type == 'add') {
                    $form.attachments = [...$form.attachments, event.detail];
                  } else if (event.detail.type == 'delete') {
                    let index = searchKeyByValue(
                      $form.attachments,
                      'fileName',
                      event.detail.fileName,
                    );
                    if (index !== -1) {
                      $form.attachments = $form.attachments.filter((_, i) => i !== index);
                    }
                  } else if (event.detail.type == 'uploading') {
                    isFormPending = true;
                  } else if (event.detail.type == 'uploaded') {
                    isFormPending = false;
                  }
                }}
                requestFrom="task_template_email"
                entityId={entityId}
                photoUrl={displayfiles}
                allFileType={true}
                allowMultiple={true}
              />
            {/if}
          </div>
        {/if}
      </div>
      <div class="modal-footer d-flex justify-content-between">
        <div>
          {#if canDelete}
            <button
              on:click={handleDelete}
              type="button"
              class="btn btn-danger m-0 px-4 font-size-12"
              data-bs-dismiss="modal"
            >
              Delete
            </button>
          {/if}
        </div>
        <div>
          <button
            type="button"
            class="trans-btn my-0 mx-3 px-4 font-size-12 outline-0 btn-cancel font-size-12"
            data-bs-dismiss="modal">Cancel</button
          >

          <button
            on:click={handleSubmit}
            type="button"
            class="btn btn-primary m-0 px-4 font-size-12"
            disabled={isFormPending}
          >
            {#if isFormPending}
              <Loader />
            {:else}Continue{/if}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
